module.exports = __webpack_public_path__ + "assets/img/thumb-ARUMALABS-1-Video.fda35770.jpg";